import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HeartIcon } from '../assets/icons/Icons';
import '../styles/notfound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-page">
      <div className="notfound-content">
        <Link to="/" className="notfound-logo">
          <div className="logo-icon">
            <HeartIcon size={20} color="white" />
          </div>
          <span className="logo-text">Ishira</span>
        </Link>

        <div className="notfound-hero">
          <div className="notfound-code">404</div>
          <h1>Page not found</h1>
          <p>
            The page you're looking for doesn't exist or has been moved.
            Let's get you back on track.
          </p>
        </div>

        <div className="notfound-actions">
          <button className="notfound-btn primary" onClick={() => navigate(-1)}>
            ← Go back
          </button>
          <Link to="/" className="notfound-btn secondary">
            Home page
          </Link>
          <a
            href="https://book.healthplix.com/dr-doctor-s-name-specialisation-place-city_198213"
            target="_blank"
            rel="noopener noreferrer"
            className="notfound-btn secondary"
          >
            Book a session
          </a>
        </div>

        <div className="notfound-help">
          <p>Need help? <Link to="/contact">Contact us</Link> or call our 24/7 helpline: <strong>1800-599-0019</strong></p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
